import React from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDotCircle } from "@fortawesome/free-solid-svg-icons";

const VirtualTourLinks = ({ facility, isPopup = false }) => {
  // If no virtual tour URL, return nothing
  if (!facility.virtualTourUrl || facility.virtualTourUrl === "") {
    return null;
  }

  // Single virtual tour link
  if (!facility.virtualTourUrl2) {
    return (
      <a href={facility.virtualTourUrl} className="btn link" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faDotCircle} size="1x" className="link-icon text-green mx-1" />
        {facility.virtualTourText}
      </a>
    );
  }

  // Multiple virtual tour links
  if (isPopup) {
    return (
      <>
        <a href={facility.virtualTourUrl} className="btn link" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faDotCircle} size="1x" className="link-icon text-green mr-1" />
          {facility.virtualTourText}
        </a>
        <a href={facility.virtualTourUrl2} className="btn link" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faDotCircle} size="1x" className="link-icon text-green mr-1" />
          {facility.virtualTourText2}
        </a>
      </>
    );
  }

  // Dropdown for non-popup contexts
  return (
    <Dropdown>
      <Dropdown.Toggle className="link m-0">Take a Virtual Tour</Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item href={facility.virtualTourUrl} target="_blank" className="popup-link">
          <FontAwesomeIcon icon={faDotCircle} size="1x" className="link-icon text-green mx-1" />
          {facility.virtualTourText}
        </Dropdown.Item>
        <Dropdown.Item href={facility.virtualTourUrl2} target="_blank" className="popup-link">
          <FontAwesomeIcon icon={faDotCircle} size="1x" className="link-icon text-green mx-1" />
          {facility.virtualTourText2}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default VirtualTourLinks;
